import React from 'react';

const ThirdPage = () => {
  return (
    <div className="page-section" style={{ paddingBottom: '0' }}>
      <div className="container mt-4">
        <div className="row align-center">
          <div className="col-md-12 text-center title-text">
            Tăng NAD+ tự nhiên-khơi dậy năng lượng và bảo vệ DNA
          </div>
        </div>
        <div className="row align-center mt-4">
          <div className="col-md-12 text-center body-text" >
          Việc bổ sung β Nicotinamide Mononucleotide (NMN) mỗi ngày là cách tự nhiên và hiệu quả <span className="d-none d-xl-inline"><br /></span>
          để tăng mức NAD+ trong cơ thể. Sau khi hấp thụ, NMN được chuyển hóa thành NAD+ <span className="d-none d-xl-inline"><br /></span>
          một coenzym thiết yếu đóng vai trò trung tâm trong quá trình trao đổi chất, sản xuất <span className="d-none d-xl-inline"><br /></span>
          năng lượng và sửa chữa DNA bị tổn thương.
          </div>
        </div>
        <div className="row align-center mt-4">
          <div className="col-md-12 text-center body-text" >
          NAD+ kích hoạt các enzyme chịu trách nhiệm phục hồi DNA, từ đó giúp bảo vệ thông tin <span className="d-none d-xl-inline"><br /></span>
          di truyền và kéo dài tuổi thọ tế bào. Đồng thời NAD+ hỗ trợ hoạt động của các gene bảo vệ, <span className="d-none d-xl-inline"><br /></span>
          làm chậm quá trình lão hóa và duy trì trạng thái trẻ trung, khỏe mạnh và tràn đầy sức sống.
          </div>
        </div>
        <div className="row align-center dna-chain-container">
          <div className="col-md-12 text-center">
            <img src="/images/dna_chain.png" alt="Product" className="img-fluid" style={{ width: '100%', maxWidth: '1100px' }} loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThirdPage; 